import React from 'react';
import { AdapterMoment } from '@mui/x-date-pickers-pro/AdapterMoment';
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers-pro';

/**
 *  MUI DatePicker with moment-timezone adapter
 * @template {import('@mui/x-date-pickers').PickerComponent} T
 * @param {{Picker: T} | ({Picker: T} & Parameters<T>[0])} props - Combined props
 * @returns {JSX.Element} The localized date picker
 * @see https://mui.com/x/api/date-pickers/date-picker/
 */
const LocalizedDatePicker = ({ Picker = DateTimePicker, ...props }) => (
    <LocalizationProvider dateAdapter={AdapterMoment}>
        <Picker {...props} />
    </LocalizationProvider>
);

export default LocalizedDatePicker;
